import { jsx as _jsx } from "react/jsx-runtime";
import { InputDateRangePicker, } from '@dixa/lib-shared-habla';
import moment from 'moment-timezone';
import { useCallback, useMemo } from 'react';
import { searchFilterDateRangePresetKeys, } from 'apis/search';
import { analytics } from 'app/utils/segment';
import { dateRangePresets } from '../../../../../../../utils/definitions';
import { maxDate, timePickerProps } from '../utils/datepickerProps';
/** Represents a date range filter */
export const ConditionFieldDateRange = ({ condition, disabled, onChange, }) => {
    /** Checks whether the selected value is a preset. */
    const isPresetValue = ({ value }) => {
        return value
            ? searchFilterDateRangePresetKeys.includes(value)
            : false;
    };
    /** The date range value passed down to the datepicker component. */
    const value = useMemo(() => {
        let startDate = null;
        let endDate = null;
        if (condition.values.length) {
            const [startValue, endValue] = condition.values;
            // If it's a preset, lookup the actual start and end dates in the preset configuration.
            if (isPresetValue(startValue)) {
                const presetKey = startValue.value;
                const presetData = dateRangePresets.find(({ key }) => key === presetKey);
                startDate = (presetData === null || presetData === void 0 ? void 0 : presetData.startDate) || moment();
                endDate = (presetData === null || presetData === void 0 ? void 0 : presetData.endDate) || moment();
            }
            else {
                startDate = startValue ? moment(startValue.value) : null;
                endDate = endValue ? moment(endValue.value) : null;
            }
        }
        return {
            startDate: (startDate === null || startDate === void 0 ? void 0 : startDate.isValid()) ? startDate : null,
            endDate: (endDate === null || endDate === void 0 ? void 0 : endDate.isValid()) ? endDate : null,
        };
    }, [condition]);
    /** Updates the condition with the new date range value. */
    const handleChange = useCallback(({ startDate, endDate, presetKey }) => {
        var _a, _b, _c, _d, _e, _f;
        // If it's a preset, the value will be the preset key and not the raw dates.
        if (presetKey) {
            const label = (_b = (_a = dateRangePresets.find(({ key }) => key === presetKey)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : '';
            const value = { label, value: presetKey || '' };
            onChange([value]);
            analytics.searchFilterValueAdded({
                type: condition.field,
                operator: condition.operator,
                value: presetKey,
            });
        }
        else {
            const startDateValue = {
                label: (_c = startDate === null || startDate === void 0 ? void 0 : startDate.format('L LT')) !== null && _c !== void 0 ? _c : '',
                value: (_d = startDate === null || startDate === void 0 ? void 0 : startDate.toISOString()) !== null && _d !== void 0 ? _d : '',
            };
            const endDateValue = {
                label: (_e = endDate === null || endDate === void 0 ? void 0 : endDate.format('L LT')) !== null && _e !== void 0 ? _e : '',
                value: (_f = endDate === null || endDate === void 0 ? void 0 : endDate.toISOString()) !== null && _f !== void 0 ? _f : '',
            };
            onChange([startDateValue, endDateValue]);
            const hasCustomStartTime = startDate
                ? startDate.format('HH:mm') !== '00:00'
                : false;
            const hasCustomEndTime = endDate
                ? endDate.format('HH:mm') !== '23:59'
                : false;
            const hasCustomTime = hasCustomStartTime || hasCustomEndTime;
            analytics.searchFilterValueAdded({
                type: condition.field,
                operator: condition.operator,
                value: hasCustomTime ? 'dateWithCustomTime' : 'dateWithDefaultTime',
            });
        }
    }, [condition, onChange]);
    return (_jsx(InputDateRangePicker, { value: value, disabled: disabled, maxDate: maxDate, dateRangePickerProps: {
            inputsPlacement: 'top',
            withDateInput: true,
            withTimePicker: true,
            timePickerProps: {
                start: timePickerProps,
                end: timePickerProps,
            },
            presets: dateRangePresets,
        }, dropdownProps: {
            fixed: true,
        }, onChange: handleChange }));
};
